/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */

import { useCallback } from 'react';
import { useSWRConfig } from 'swr';

const useRevalidation = () => {
    const { mutate, cache } = useSWRConfig();

    // Use to revalidate based on key with optional data
    const revalidate = useCallback((key: string, data?: any) => {
        let cachedData = cache.get(key)?.data;
        if (cachedData) {
            mutate(key, data);
            return;
        }

        // Happened in the case where there are query params (/bff/...?page=1)
        const keyWithParams = [...cache.keys()].find((k) => k.startsWith(key));
        if (keyWithParams) {
            cachedData = cache.get(keyWithParams)?.data;
            if (cachedData) {
                mutate(keyWithParams);
            }
        }
    }, []);

    return revalidate;
};

export default useRevalidation;
